// Notifications reducer
const initialStateForWebNotifications = {
  fetching: false,
  fetched: false,
  items: [],
  error: null,
  updated: false,
  updating: false,
  nbResult: 0
};

export const webNotificationsReducer = (
  state = initialStateForWebNotifications,
  action
) => {
  switch (action.type) {
    case "FETCH_WEB_NOTIFICATIONS_PENDING": {
      return { ...state, fetched: false, fetching: true };
    }
    case "FETCH_WEB_NOTIFICATIONS_FULFILLED": {
      const { data, nbResult } = action.payload.data;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data,
        nbResult: nbResult
      };
    }
    case "FETCH_WEB_NOTIFICATIONS_REJECTED": {
      let error = action.payload;
      switch (error && error.response && error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        items: [],
        error
      };
    }
    case "READ_NOTIFICATION_PENDING": {
      return { ...state, updated: false, updating: true };
    }
    case "READ_NOTIFICATION_FULFILLED": {
      const { payload } = action;
      let updatedItems = state.items.map(item => {
        if (item.id === payload.id) {
          return { ...item, status: "READ" };
        }
        return item;
      });
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        updated: true,
        updating: false,
        items: updatedItems
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/notifications.js